var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('va-create-layout',[_c('videos-form',{attrs:{"id":_vm.id,"title":_vm.title,"is-create":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }